import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { ServerPath } from '../../shared/constants';
import axios from 'axios';
import Spinner from '../../components/common/Spinner';
import moment from 'moment';
import AOS from "aos";
import "aos/dist/aos.css";

const BoardDetail = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [ item, setItem ] = useState({});
  const [show, setShow] = useState(true);
  const [textAreaHeight, setHeight] = useState(1240)
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    AOS.init();
    const onInit = async () => {

      const token = localStorage.getItem('userToken');
      
      const id = params.id;
      var senddata = {};
      if (params.type==='news')
        senddata = {newsId: id}
      else
        senddata = {noticeId : id}
  
      let url;
      params.type==='news'? url = '/news/detail': url = '/notice/detail';
  
      axios
        .post(ServerPath + url , senddata, { headers: { Authorization: `Bearer ${token}` } } )
        .then((data) => {
          setItem(data.data);
          const conetentLength = window.innerWidth / 400;
          const lineLength = window.innerWidth / 10;
          if (data.data.content_kor !== undefined)
            setHeight(data.data.content_kor.length*conetentLength + data.data.content_kor.split('\n').length*lineLength);
          
          setIsLoaded(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    onInit();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll); //clean up
    };

  }, []);

  const handleScroll = () => {
    if (window.scrollY !== 0) {
      setShow(false);
    } else {
      setShow(true);
    }
  };


  const linkTo = (link) => {
    navigate('/' + link);
  }

  return !isLoaded ? (
      <Spinner />
  ) : (
    <section> 
    {show ?
      <div className="backBtn" >
        <span onClick={() =>linkTo('news')}>
          <i className="fa-solid fa-arrow-left"></i>
        </span>
      </div>
      :''
    }

       <div className="taps">

        <div className="tap_bt tapon">{params.type} </div>
      </div>

      <div className="board_title">
         {item.title_kor}
      </div>

      <div className="board_date">
         {moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}
      </div>

      <div className="board_image">
          <img src={item.image_kor} alt={"image" + item.id}/>
      </div>

      <div className="board_content">
        <textarea
         style={{
          height: textAreaHeight,

        }}
        value = {item.content_kor}
        readOnly
         />
      </div>
    </section>
    
  );
};

const mapStateToProps = ({ authUser }) => {
  const { currentUser } = authUser;
  return {currentUser}
};

export default connect(mapStateToProps, null)(BoardDetail);

